"use client";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

interface ProcessStep {
  end: number;
}

const Counter: React.FC<ProcessStep> = ({ end }) => {
  const { ref, inView } = useInView({ triggerOnce: true });

  return (
    <span className="count" ref={ref}>
      {inView && (
        <CountUp end={end ?? 100} duration={3} />
      )}
    </span>
  );
};

export default Counter;
